/**
 * Strings em português (padrão).
 * Cada chave aqui é a fonte da verdade — outras locales devem ter a MESMA chave.
 *
 * Suporta interpolação simples: "Erro: {msg}" → t('toast.encodeError', { msg: 'foo' })
 */
export default {
  // hero (H1 visível + subtitle + trust badges)
  'hero.title': 'Shrink. Reduza o tamanho das suas imagens. Grátis, sem limite.',
  'hero.subtitle': 'Reduza até 80% do tamanho. PNG, JPEG, WebP. Sem upload, sem login. 100% no seu navegador.',
  'hero.badge1': '100% grátis',
  'hero.badge2': 'Sem limite de quantidade',
  'hero.badge3': 'Sem upload — privado',
  'hero.badge4': 'Sem cadastro',
  'hero.badge5': 'Sem perda visível de qualidade',

  // header
  'header.title': 'Shrink',

  // dropzone
  'dropzone.title': 'Arraste suas imagens',
  'dropzone.subtitle': 'ou clique para selecionar',
  'dropzone.meta': 'PNG, JPEG, WebP · até 20 MB · quantos quiser',
  'dropzone.ariaLabel': 'Arraste ou selecione imagens para comprimir',
  'dropzone.warning': 'Processando {count} arquivos — o desempenho pode cair',
  'dropzone.hint': 'Suas imagens ficam aqui',

  // file list
  'fileList.queued': 'Na fila',
  'fileList.processing': 'Comprimindo…',
  'fileList.done': 'Concluído',
  'fileList.error': 'Erro',
  'fileList.noReduction': 'Sem redução',
  'fileList.larger': 'Maior',
  'fileList.removeAria': 'Remover {filename}',

  // download
  'download.button': 'Baixar tudo (ZIP)',
  'download.loading': 'Gerando ZIP…',
  'download.empty': 'Nenhum arquivo pra baixar ainda',
  'download.success': 'ZIP baixado ({count} arquivos)',

  // progress indicator
  'progress.processing': 'Comprimindo {done} de {total}…',
  'progress.doneWithError': '{done} prontos, {error} com erro',
  'progress.done': '{done} de {total} prontos',

  // toasts
  'toast.unsupportedType': 'Formato .{ext} não é suportado',
  'toast.tooLarge': 'Arquivo muito grande ({size}). Máximo 20 MB',
  'toast.oomError': 'Sem memória para processar. Tente lotes menores',
  'toast.encodeError': 'Falha ao processar imagem',
  'toast.sanitizeError': 'Nome de arquivo inválido',

  // features (SEO content)
  'features.title': 'Por que comprimir imagens?',
  'features.subtitle': 'Imagens menores significam mais velocidade, menos armazenamento e compartilhamento sem fricção.',
  'features.webTitle': 'Páginas web mais rápidas',
  'features.webDesc': 'Imagens são o principal gargalo de performance. Comprimir reduz o Largest Contentful Paint (LCP), melhora o ranking no Google e diminui bounce rate.',
  'features.emailTitle': 'Emails que cabem no limite',
  'features.emailDesc': 'Gmail limita anexos em 25MB. Uma foto não comprimida tem 8-15MB — você cabe só 2-3. Comprimido, manda álbuns inteiros em um email.',
  'features.chatTitle': 'Mensagens sem compressão automática',
  'features.chatDesc': 'WhatsApp, Telegram e Discord comprimem imagens automaticamente (perdendo qualidade). Envie a versão já otimizada e mantenha a nitidez.',
  'features.storageTitle': 'Menos armazenamento',
  'features.storageDesc': 'Reduza o uso de disco, backup e cloud (Google Drive, iCloud, Dropbox). Em 1.000 fotos a 2MB cada, comprimir 50% libera 1GB.',
  'features.mobileTitle': 'Economiza dados do celular',
  'features.mobileDesc': 'Em 4G/5G, uma foto não comprimida consome o plano inteiro. Comprimida, você cabe 5x mais fotos no mesmo pacote de dados.',
  'features.costTitle': 'Menos bandwidth, menos custo',
  'features.costDesc': 'Cloudflare, AWS, Vercel — cada byte economizado é centavo poupado. Sites com 1 TB/mês de imagens podem economizar centenas de reais em hosting e CDN.',

  // how it works
  'howItWorks.title': 'Como funciona',
  'howItWorks.step1Title': 'Solte suas imagens',
  'howItWorks.step1Desc': 'Arraste e solte arquivos PNG, JPEG ou WebP. Ou clique para selecionar. Sem limite de quantidade.',
  'howItWorks.step2Title': 'Compressão automática',
  'howItWorks.step2Desc': 'O processamento roda direto no seu navegador via WebAssembly. Sem upload. Cada arquivo mostra o tamanho original, o comprimido e a % economizada.',
  'howItWorks.step3Title': 'Baixe tudo em um ZIP',
  'howItWorks.step3Desc': 'Um clique baixa todos os arquivos comprimidos em um único ZIP, com os nomes originais preservados.',

  // footer
  'footer.disclaimer': 'Sem login · sem upload · 100% no seu navegador',
  'footer.howItWorks': 'Como funciona',
  'footer.features': 'Por que comprimir',
  'footer.privacy': 'Privacidade',
  'footer.terms': 'Termos',
  'footer.contact': 'Contato',
  'footer.about': 'Sobre',

  // Páginas legais (Privacy, Terms, Contact, About)
  'legal.lastUpdated': 'Última atualização',
  'common.skip': 'Pular para o conteúdo',
  'common.backHome': '← Voltar pro Shrink',

  // Política de Privacidade
  'privacy.title': 'Política de Privacidade',
  'privacy.lead':
    'Shrink é uma ferramenta gratuita de compressão de imagens que roda 100% no seu navegador. Esta política explica, em linguagem simples, quais dados coletamos (quase nenhum), por quê, e quais são seus direitos.',
  'privacy.s1Title': '1. A versão curta',
  'privacy.s1Body':
    'Não vemos, armazenamos ou transmitimos suas imagens. A compressão acontece localmente no seu navegador via WebAssembly. Não exigimos conta, email ou qualquer informação pessoal. O único terceiro que pode definir cookies é o Google AdSense, que exibe anúncios para usuários gratuitos.',
  'privacy.s2Title': '2. O que coletamos',
  'privacy.s2Body': 'Por padrão, não coletamos nada sobre você. Especificamente:',
  'privacy.s2Item1': 'Nenhuma imagem, nome de arquivo ou metadado sai do seu dispositivo.',
  'privacy.s2Item2': 'Não exigimos conta, email ou nome.',
  'privacy.s2Item3': 'Nenhum analytics, pixel de rastreamento ou fingerprinting nosso.',
  'privacy.s2Item4':
    'O único dado que guardamos localmente é a sua preferência de idioma (um valor no localStorage do navegador), para que o site mantenha o idioma escolhido na próxima visita. Você pode limpar quando quiser.',
  'privacy.s3Title': '3. Serviços de terceiros: Google AdSense',
  'privacy.s3Body':
    'Para manter o Shrink gratuito, exibimos anúncios do Google AdSense. O AdSense usa cookies para exibir anúncios com base nas suas visitas anteriores a este ou outros sites. O uso de cookies de publicidade pelo Google permite que ele e seus parceiros exibam anúncios baseados na sua visita a este site e/ou outros sites na Internet.',
  'privacy.s3Body2':
    'Você pode desativar a publicidade personalizada nas Configurações de Anúncios do Google. Também pode desativar o uso de cookies por certos terceiros para publicidade personalizada em www.aboutads.info.',
  'privacy.s4Title': '4. Cookies que definimos',
  'privacy.s4Body':
    'Não definimos cookies de rastreamento ou analytics próprios. O único armazenamento próprio é a preferência de idioma no localStorage. O Google AdSense pode definir cookies sob a própria política; veja a Seção 3.',
  'privacy.s5Title': '5. GDPR (Espaço Econômico Europeu)',
  'privacy.s5Body':
    'Se você está no EEE, a base legal para tratamento sob o Regulamento Geral de Proteção de Dados é seu consentimento (para anúncios personalizados via AdSense) ou interesse legítimo (para a operação básica do site). Você tem o direito de acessar, retificar, apagar, restringir, opor-se e portar seus dados pessoais. Para exercer esses direitos, entre em contato pelo privacy@goodtool.site.',
  'privacy.s6Title': '6. CCPA / CPRA (Califórnia)',
  'privacy.s6Body':
    'Se você é residente da Califórnia, tem o direito de saber quais informações pessoais são coletadas, de deletá-las e de optar por não vendê-las ou compartilhá-las. Não vendemos informações pessoais. O AdSense pode compartilhar informações com o Google para personalização de anúncios; você pode desativar nas Configurações de Anúncios do Google.',
  'privacy.s7Title': '7. LGPD (Brasil)',
  'privacy.s7Body':
    'A Lei Geral de Proteção de Dados (LGPD) garante os seguintes direitos: confirmação da existência de tratamento, acesso, correção, anonimização, portabilidade, eliminação e revogação do consentimento. Para exercer esses direitos, entre em contato pelo privacy@goodtool.site.',
  'privacy.s8Title': '8. Privacidade de crianças',
  'privacy.s8Body':
    'O Shrink não é direcionado a crianças menores de 13 anos, e não coletamos intencionalmente informações pessoais de crianças. O serviço pode ser usado por qualquer pessoa independentemente da idade sem fornecer dados pessoais, em conformidade com COPPA e leis similares.',
  'privacy.s9Title': '9. Transferências internacionais de dados',
  'privacy.s9Body':
    'Não transferimos seus dados porque não os coletamos. Os dados do AdSense são processados pelo Google sob a política deles, o que pode envolver transferência e processamento nos Estados Unidos e outros países.',
  'privacy.s10Title': '10. Mudanças nesta política',
  'privacy.s10Body':
    'Podemos atualizar esta política periodicamente. A data "Última atualização" no topo desta página reflete quando a política foi revisada pela última vez. O uso contínuo do Shrink após uma alteração indica aceitação da política atualizada.',
  'privacy.s11Title': '11. Contato',
  'privacy.s11Body':
    'Dúvidas ou solicitações sobre esta política: privacy@goodtool.site. Respondemos em alguns dias úteis.',

  // Termos de Serviço
  'terms.title': 'Termos de Serviço',
  'terms.lead':
    'Ao usar o Shrink você concorda com estes termos. A versão curta: é grátis, funciona no seu navegador, use com responsabilidade, sem garantias.',
  'terms.s1Title': '1. Aceitação',
  'terms.s1Body':
    'Ao acessar ou usar o Shrink (shrink.goodtool.site), você concorda em estar vinculado a estes Termos de Serviço. Se você não concorda, não use o serviço.',
  'terms.s2Title': '2. Descrição do serviço',
  'terms.s2Body':
    'O Shrink é uma ferramenta gratuita de compressão de imagens no lado do cliente. Ela roda inteiramente no seu navegador usando WebAssembly. Não hospedamos, armazenamos ou transmitimos suas imagens. O serviço é fornecido "como está" e "conforme disponibilidade", sem garantias de qualquer tipo.',
  'terms.s3Title': '3. Responsabilidades do usuário',
  'terms.s3Body': 'Você concorda em usar o Shrink apenas para fins legais. Você não vai:',
  'terms.s3Item1': 'Usar o serviço para processar imagens sobre as quais não tem direito de compressão.',
  'terms.s3Item2': 'Tentar interromper, sobrecarregar ou abusar do serviço ou sua infraestrutura.',
  'terms.s3Item3': 'Usar scraping automatizado ou acesso em massa além do uso normal do navegador.',
  'terms.s4Title': '4. Propriedade intelectual',
  'terms.s4Body':
    'O código-fonte, design e marca do Shrink são de propriedade do editor. O serviço em si é fornecido sem custo. Suas imagens continuam sendo suas o tempo todo — nunca vemos, armazenamos ou reivindicamos direitos sobre elas.',
  'terms.s5Title': '5. Serviços de terceiros',
  'terms.s5Body':
    'O Shrink exibe anúncios do Google AdSense. O AdSense é regido pelos termos e política de privacidade do Google. Não somos responsáveis pelo conteúdo do AdSense, mas o escolhemos como parceiro porque oferece controles de opt-out padrão do mercado.',
  'terms.s6Title': '6. Isenção de garantias',
  'terms.s6Body':
    'O serviço é fornecido "como está", sem garantias de qualquer tipo, expressas ou implícitas, incluindo mas não se limitando a garantias de comerciabilidade, adequação a uma finalidade específica e não violação. Não garantimos que o serviço será ininterrupto, seguro ou livre de erros, ou que os resultados de compressão atenderão aos seus requisitos específicos.',
  'terms.s7Title': '7. Limitação de responsabilidade',
  'terms.s7Body':
    'Na extensão máxima permitida por lei, o editor do Shrink não será responsável por quaisquer danos indiretos, incidentais, especiais, consequenciais ou punitivos, incluindo perda de dados, decorrentes do uso do serviço. Se o serviço causou danos diretos apesar do acima, nossa responsabilidade total é limitada a USD $10.',
  'terms.s8Title': '8. Mudanças nos termos',
  'terms.s8Body':
    'Podemos atualizar estes termos periodicamente. A data "Última atualização" no topo desta página reflete a revisão mais recente. O uso contínuo do Shrink após uma alteração indica aceitação dos termos atualizados.',
  'terms.s9Title': '9. Contato',
  'terms.s9Body':
    'Dúvidas sobre estes termos: legal@goodtool.site.',

  // Página de Contato
  'contact.title': 'Contato',
  'contact.lead':
    'Dúvidas, feedback, relatórios de bug ou ideias de parceria? Mande um email. Lemos tudo e respondemos em alguns dias úteis.',
  'contact.emailTitle': 'Email',
  'contact.emailDesc': 'Para perguntas gerais, pedidos de funcionalidade e relatórios de bug.',
  'contact.privacyTitle': 'Privacidade e pedidos de dados',
  'contact.privacyDesc':
    'Para perguntas sobre privacidade, pedidos GDPR / CCPA / LGPD, ou para exercer seus direitos de dados.',
  'contact.responseTitle': 'Tempo de resposta',
  'contact.responseDesc':
    'Miramos responder em 1-3 dias úteis. Somos uma equipe pequena, então agradecemos pela paciência.',

  // Página Sobre
  'about.title': 'Sobre o Shrink',
  'about.lead':
    'Shrink é um compressor de imagens gratuito, sem cadastro, que roda inteiramente no seu navegador. Sem upload, sem conta, sem rastreamento. Suas imagens nunca saem do seu dispositivo.',
  'about.missionTitle': 'Nossa missão',
  'about.missionBody':
    'Tornar a compressão de imagens rápida, privada e gratuita para todos. Nosso foco é construir a melhor ferramenta possível — sem cadastro, sem upload, sem espera — e mantê-la gratuita para que qualquer pessoa possa usar, em qualquer lugar.',
  'about.whyClientTitle': 'Por que client-side?',
  'about.whyClientBody':
    'Porque privacidade não é um recurso que você liga — é o padrão. Ao rodar no seu navegador, tornamos fisicamente impossível vermos suas imagens: a requisição de rede nunca acontece. Isso também significa processamento mais rápido (sem round-trip de upload) e zero custo de servidor, então o serviço pode se manter gratuito pra sempre.',
  'about.whoTitle': 'Quem construiu',
  'about.whoBody':
    'O Shrink é construído e mantido por uma pequena equipe que se importa com performance web e privacidade do usuário. Construímos porque queríamos uma ferramenta que simplesmente funciona — e decidimos compartilhar com qualquer pessoa que precise.',
  'about.fundingTitle': 'Como é financiado',
  'about.fundingBody':
    'O Shrink é gratuito, sem planos pagos, sem upsells e sem tier premium. É sustentado por anúncios discretos do Google AdSense. Se você quer apoiar o projeto de outras formas, entre em contato pelo contact@goodtool.site.',

  // FAQ (acordeão visível, + SEO + AdSense)
  'faq.title': 'Perguntas frequentes',
  'faq.q1': 'O Shrink é realmente 100% grátis?',
  'faq.a1': 'Sim, 100% grátis sem custos ocultos. Sem cadastro, sem email, sem cartão de crédito, sem limite de uso. Você pode comprimir imagens ilimitadas, mesmo centenas de uma vez, tudo de graça.',
  'faq.q2': 'Minhas imagens são enviadas para um servidor?',
  'faq.a2': 'Não. Toda a compressão acontece no seu navegador usando WebAssembly. Suas imagens nunca tocam em servidor, nem no nosso. Você pode até usar o Shrink offline depois de carregar a página uma vez. Isso torna mais seguro que alternativas na nuvem para imagens sensíveis.',
  'faq.q3': 'Existe um limite no número de imagens?',
  'faq.a3': 'Não. Solte cem imagens de uma vez se quiser. O único limite é 20MB por arquivo. Processamos em paralelo usando um pool de Web Workers, depois baixa tudo em um único ZIP.',
  'faq.q4': 'Quanto as imagens podem ser reduzidas?',
  'faq.a4': 'Redução típica é 50-80%. Screenshots e imagens de UI com grandes áreas de cor sólida podem chegar a 80% ou mais. Fotos geralmente reduzem 40-65%. A redução exata depende do conteúdo da imagem, não apenas do formato.',
  'faq.q5': 'Quais formatos são suportados?',
  'faq.a5': 'PNG, JPEG e WebP. A saída mantém o mesmo formato da entrada — nunca convertemos entre formatos. Cada formato é comprimido com um engine dedicado e otimizado: PNG usa libimagequant, JPEG usa MozJPEG, WebP usa libwebp.',
  'faq.q6': 'Por que reduzir o tamanho de imagens para meu site?',
  'faq.a6': 'Imagens menores carregam mais rápido. O Google usa velocidade de página (Core Web Vitals) como fator de ranking, e imagens geralmente são o maior gargalo. Reduzir suas imagens melhora o Largest Contentful Paint (LCP), reduz bounce rate e aumenta SEO. Sites típicos veem 1-3 segundos mais rápidos após reduzir imagens.',
  'faq.q7': 'Por que reduzir imagens antes de enviar por email?',
  'faq.a7': 'O Gmail limita anexos em 25MB. Uma foto não comprimida tem facilmente 8-15MB, então você só consegue anexar 2-3 fotos por email. Imagens reduzidas permitem enviar álbuns inteiros em um email. O destinatário também recebe mais rápido, e sua pasta de enviados fica menor.',
  'faq.q8': 'As imagens reduzidas vão parecer diferentes?',
  'faq.a8': 'A redução de PNG e WebP usa quantização inteligente que preserva a qualidade visual. A maioria das pessoas não percebe diferença nas configurações padrão, mesmo com zoom. JPEG usa MozJPEG em qualidade 80, que é o sweet spot entre qualidade percebida e tamanho de arquivo.',
};
